import React, { useState, useEffect, useRef } from 'react';
import { Palette } from 'lucide-react';

const BG_COLORS = [
    { hex: '#FFFFFF', label: 'Clear' },
    { hex: '#FFF2ED', label: 'Velocity Orange' },
    { hex: '#FFF1EC', label: 'Ocean Blue' },
    { hex: '#ECFDF5', label: 'Mint Green' },
    { hex: '#FFFBEB', label: 'Warm Amber' },
    { hex: '#F8F9FA', label: 'Slate Grey' },
    { hex: '#FEF2F2', label: 'Soft Red' }
];

const TableBgDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (hex) => {
        editor.chain().focus().setCellAttribute('bgcolor', hex === '#FFFFFF' ? null : hex).run();
        setIsOpen(false);
    };

    return (
        <div className="list-style-dropdown-container" ref={dropdownRef}>
            <button
                className="toolbar-btn"
                onClick={() => setIsOpen(!isOpen)}
                title="Cell Brand Color"
            >
                <Palette size={15} />
                <span className="toolbar-tooltip">Cell Brand Color</span>
            </button>
            {isOpen && (
                <div className="library-dropdown-menu" style={{ width: '150px', padding: '6px' }}>
                    <div className="library-dropdown-title">Cell Background</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                        {BG_COLORS.map((col) => (
                            <button
                                key={col.hex}
                                className="toolbar-dropdown-item text-left"
                                onClick={() => handleSelect(col.hex)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '8px',
                                    width: '100%', border: 'none', background: 'transparent',
                                    padding: '6px 8px', borderRadius: '4px', cursor: 'pointer',
                                    textAlign: 'left'
                                }}
                            >
                                <span style={{ width: '12px', height: '12px', background: col.hex, border: '1px solid #CBD5E1', borderRadius: '2px' }} />
                                <span style={{ fontSize: '11px', fontWeight: '500' }}>{col.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TableBgDropdown;
